import { render, staticRenderFns } from "./Codes.vue?vue&type=template&id=bf6ae86e&scoped=true"
import script from "./Codes.vue?vue&type=script&lang=js"
export * from "./Codes.vue?vue&type=script&lang=js"
import style0 from "./Codes.vue?vue&type=style&index=0&id=bf6ae86e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf6ae86e",
  null
  
)

export default component.exports